/* eslint-disable no-use-before-define */
import React from 'react'
import { useOrderTicket } from '../../use-order-ticket'
import { arrayFrom, fmt, parseHtml, Loading, sortFn, show, parseDate } from '../../../twd'

export let Positions = () => {
    const {
        positions, positionsStatus, positionsCount,
        cusip, qty, action,
    } = useOrderTicket()


    const [selected, setSelected] = React.useState(arrayFrom(positions).filter(p => p.cusip===cusip)[0] || null)

    return <React.Fragment>
        <Loading status={positionsStatus}>
        <div className="row vertical-offset-xs"></div>

        {positionsCount===0 && <React.Fragment>
            <div className="row text-center vertical-offset-xs">
                <div className="vertical-offset-xs">
                <i className="et-icon et-alert et-icon-md" aria-hidden="true"></i>
                </div>
                <div className="vertical-offset-xs">
                <div className="small-header vertical-offset-xxs">There are no positions in this account.</div>
                </div>
            </div>
        </React.Fragment>}

        {positionsCount>0 && <React.Fragment>
            <div className="row vertical-offset-xs">
            <div className="col-md-12 col-xs-12">
                Select a fixed income position to sell or buy. (Note: This may clear any order information already entered.)
            </div>
            </div>

            <div className="row vertical-offset-sm">
            <div className="col-md-12 col-xs-12 table-responsive"
                style={{display:"block", maxHeight:"450px"}}>
            <Grid {...{positions, cusip, qty, action, setSelected}} />
            </div>
            </div>

            <div className="row vertical-offset-xs">
            <div className="col-md-12 col-xs-12">
                Showing all positions for the active account.
            </div>
            </div>

            <div className="row">
            <div className="col-md-12 col-xs-12">
                <Buttons {...{selected}} />
            </div>
            </div>
        </React.Fragment>}
        </Loading>
    </React.Fragment>
}


const Grid = ({positions, cusip, qty, action, setSelected }) => {

    return <React.Fragment>
        <table
            className="table align-top"
        >
        <thead>
            <tr>
            <th className="col-md-1">&nbsp;</th>
            <th className="col-md-5">Issuer/CUSIP</th>
            <th className="col-md-2 text-right">Quantity</th>
            <th className="col-md-2 text-right">Coupon</th>
            <th className="col-md-2 text-right">Maturity</th>
            </tr>
        </thead>

        <tbody>
            { arrayFrom(positions)
            .filter(({maturity}) => {
                const isMatured = parseDate(maturity) < Date.now()
                return !isMatured
            })
            .sort(sortFn(({issue, maturity}) => {
                return (issue || '').trim() + fmt.fmtDt(parseDate(maturity), 'yyyy-MM-dd')
            }))
            .map((p,i) => {

                const [el, setEl] = React.useState(null)
                return <tr key={i}>
                    <td>
                        <input
                            ref={setEl}
                            type="radio"
                            name="order-ticket-positions-select"
                            value={p}
                            aria-label={`${p.issue}/${p.cusip}`}
                            defaultChecked={p.cusip===cusip && (action==='B' || p.qty===qty)}
                            onChange={() => { setSelected(p)} }
                        />
                    </td>
                    <td style={{maxWidth:'200px'}}>
                        <button
                        className="link-button text-truncate text-left"
                        style={{ width:'100%' }}
                        onClick={() => {
                            if (!el) return
                            el.checked = true
                            setSelected(p)
                        }}
                        >{parseHtml(p.issue)}</button>
                        <br/>
                        {p.cusip}
                    </td>
                    <td className="text-right">{fmt.qty(p.qty)}</td>
                    <td className="text-right">{fmt.cpn3(p.coupon)}</td>
                    <td className="text-right">{fmt.mdy(p.maturity)}</td>
                </tr>

            }) }

        </tbody>
        </table>
    </React.Fragment>
}

const Buttons = ({selected, }) => {
    return <React.Fragment>
        <button
            disabled={!selected}
            aria-disabled={!selected}
            className="btn btn-primary-outline"
            onClick={() => {
                show('order-ticket', {
                    action:'S',
                    acctNo:selected.acct_no,
                    cusip:selected.cusip,
                    qty:selected.qty,
                    sourceAction:'H',
                    ts: Date.now(),
                })
            }}>Sell</button>
        <span aria-hidden={true} style={{padding:'0 0 0 10px'}}></span>
        <button
            disabled={!selected}
            aria-disabled={!selected}
            className="btn btn-primary-outline"
            onClick={() => {
                show('order-ticket', {
                    action:'B',
                    acctNo:selected.acct_no,
                    cusip:selected.cusip,
                    ts: Date.now(),
                })
            }}>Buy</button>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/order-ticket/snapshot/positions/positions.js